import React from 'react';
import OperatorRequestBase from './OperatorRequestBase';
import CierreMensualForm from '../../components/requests/CierreMensualForm';
import { useAuth } from '../../context/AuthContext';

const OperatorCierreMensual = () => {
  const { isGlobalAdmin } = useAuth();
  const basePath = isGlobalAdmin() ? '/global-admin' : '/operator';

  return (
    <OperatorRequestBase
      title="Cierre Mensual"
      description="Prepara el cierre contable del cliente para el periodo seleccionado."
      requestType="cierre_mensual"
      FormComponent={CierreMensualForm}
      backHref={`${basePath}/workspace`}
    />
  );
};

export default OperatorCierreMensual;
